import { IS_DEVNET, IS_TESTNET } from '@shared/utils/constant'
import { MegaVaultChartDuration } from '@/types'

export const MEGA_VAULT_WHITELIST = [
  'inj1995xnrrtnmtdgjmx0g937vf28dwefhkhy6gy5e',
  'inj17gkuet8f6pssxd8nycm3qr9d9y699rupv6397z',
  'inj1hkhdaj2a2clmq5jq6mspsggqs32vynpk228q3r',
  'inj16jggg2wqkf65jcdea9zw0kfx2eqd29e8m9c2n7',
  'inj1m8qm2clemt3qd6akdk8erdmjd62zdael6swazw',
  'inj1xuyfug6hkkafjf0fwmd4vyrp6ns5jk99zn2t0d',
  'inj16c6qt2sp99s9xekfjhc6mztpaugee7regf6rue',
  'inj1spp27p48vpkyvclwu3g62ley0ulgvd3l44hq5y',
  'inj1wrg096y69grgf8yg6tqxnh0tdwx4x47rsj8rs3',
  'inj13w3wsag08wa6qc092cekvm52h69e5ysge7vnmf',
  'inj1qmcv6lachfep0gqv2hwxl2sp6k4ywwegppyl3t',
  'inj1n0lgv0hgh6ut2f4u9ja04x33uk0kh62h2mp5jh',
  'inj1cd0d4l9w9rpvugj8upwx0pt054v2fwtr563eh0',
  'inj1gucfnr3jj0v3n965ce502ed534de2p0ggd6ecy',
  'inj1lk5t6q79y3juwg7x8w4hvsyn0sml3w8cvlhnzk',
  'inj1zs3mzfeetw5k0sadvr7sjqxkru65vxlh0yf64d',
  'inj1dtc9wkpp8cvv0c7gtrmag3h3tjhv25dfu7aj4s',
  'inj1qfwyc6s84wn5h8gwksdr906ee59ruj422x8334',
  'inj1547t7uhysk68qcdz7nswev38etq4ls0wgr88vc',
  'inj1q4fgypsqdxk2p5punfhut0stz7jchnx7tc56av',
  'inj1mf54qzss29pyk450lkdpa2rqpn38hzcexfpyac',
  'inj12nq3pzec7gr35u0den42udjlzn9snkyr6w5kra'
]

export const MEGA_VAULT_CONTRACT_ADDRESS = IS_DEVNET
  ? 'inj1qv74a65wmarqwn6lhuj3mzwgn9jpljc2nk5d4e'
  : IS_TESTNET
    ? 'inj10whcxm6gj3c8vrz69l3zpnmpekl20hzykg76uz'
    : 'inj1qkk0t9cq8r3luqz9ayjh76xk385cmy9clgcfs9'

export const LP_TOKEN_DECIMALS = 18
export const LP_TOKEN_DENOM = `factory/${MEGA_VAULT_CONTRACT_ADDRESS}/lp`

export const MEGA_VAULT_MIN_DEPOSIT_USDT = 10
export const MEGA_VAULT_MIN_WITHDRAW_USDT = 10

export const MEGA_VAULT_REFRESH_INTERVAL = 30 * 1000
export const MEGA_VAULT_PENDING_REFRESH_INTERVAL = 5 * 1000

export const MEGA_VAULT_DEFAULT_CHART_DURATION = MegaVaultChartDuration.OneMonth
